import React from 'react';
import { cva } from '@zs-nimbus/core/utils';

export type AvDividerProps = {
  variant?: 'default' | 'info' | null;
};

const dividerVariants: (props?: AvDividerProps) => string = cva('my-2.5 border-0 border-t border-solid', {
  variants: {
    variant: {
      default: 'border-border-base-primary',
      info: 'border-border-status-info-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export const AvDivider: React.FC<AvDividerProps> = ({ variant }) => <hr className={dividerVariants({ variant })} />;
